import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api'
const API_KEY = import.meta.env.VITE_API_KEY

// Vytvoření Axios instance s výchozím nastavením
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'x-api-key': API_KEY,
  },
  withCredentials: true,
})

// Interceptor pro přidání tokenu a Content-Type
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  
  // Nastavení Content-Type pouze pokud není multipart/form-data
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }
  
  return config
})

// Interceptor pro zpracování chyb
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken')
      window.location.href = '/admin'
    }
    return Promise.reject(error)
  }
)

// API funkce
export async function login(username: string, password: string) {
  const response = await apiClient.post('/auth', { username, password })
  return response.data
}

export async function getPhotos() {
  try {
    const response = await apiClient.get("/gallery");
    return response.data;
  } catch (error) {
    console.error("Chyba při načítání fotografií:", error);
    throw error;
  }
}

export async function uploadPhoto(file: File, uploadedBy: string) {
  const CHUNK_SIZE = 1024 * 1024; // 1MB chunks
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const filename = `${Date.now()}_${file.name}`;

  // Připravíme všechny chunky najednou
  const chunks = Array.from({ length: totalChunks }, (_, chunkIndex) => {
    const start = chunkIndex * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    return file.slice(start, end);
  });

  // Převedeme chunky na base64 postupně
  const base64Chunks: string[] = [];
  for (const chunk of chunks) {
    const base64 = await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result as string;
        resolve(base64.split(',')[1]);
      };
      reader.readAsDataURL(chunk);
    });
    base64Chunks.push(base64);
  }

  // Nahráme chunky postupně
  for (let chunkIndex = 0; chunkIndex < base64Chunks.length; chunkIndex++) {
    const response = await apiClient.post('/gallery/chunk', {
      chunk: base64Chunks[chunkIndex],
      filename,
      chunkIndex,
      totalChunks,
      uploadedBy
    });

    if (response.status !== 201) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }

  return { success: true };
}

export async function deletePhoto(id: string) {
  const response = await apiClient.delete(`/gallery?id=${id}`)
  return response.data
}

export async function getRsvps() {
  const response = await apiClient.get('/rsvp')
  return response.data
}


export async function deleteRsvp(id: string) {
  const response = await apiClient.delete(`/rsvp?id=${id}`)
  return response.data
} 

const URL = 'https://script.google.com/macros/s/AKfycbwNH5VgZ6VlV0WKcOWXZHIpZ_QUCweEW6ZdvzsqRF1wO7GbnfdNyC_TvGMgHgA607vTeg/exec'

export const getGuestList = async (): Promise<{ data: { id: string; name: string, count: number }[] }> => {
  const paramData = { key: "all" };

  // Fetch API data
  const response = await fetch(`${URL}?${new URLSearchParams(paramData).toString()}`, {
    method: "GET",
  });
  return response.json();
};

const URL_GUEST_LIST = 'https://script.google.com/macros/s/AKfycbzKaSh5XjSi6bMseU0uS960Y0Uvpc7eTzT7Su3iqmN9fiJNlWj35Z6FcqN-vGiwlHnBag/exec'


export const getGuestListId = async (svatebcanId: string): Promise<{ id: number; name: string, count: number }> => {
  const paramData = { key: "all" };

  // Fetch API data
  const response = await fetch(`${URL_GUEST_LIST}?${new URLSearchParams(paramData).toString()}`, {
    method: "GET",
  });
  const json = await response.json();
  return json.data.find((item: { id: number; name: string, count: number }) => item.id.toString() === svatebcanId);
};

export const handlePostRsvp = async (inputValue: { [key: string]: string }) => {
    const formData = new FormData();
		for (const key in inputValue) {
			formData.append(key, inputValue[key]);
		}
		console.log(formData);
		try {
			const res = await fetch(URL, {
				method: "POST",
				body: formData,
			});
			if (res.ok) {
				console.log("Request was successful:", res);
			} else {
				console.log("Request Failed:", res);
			}
		} catch (e) {
			console.error("Error during fetch:", e);
		}
	};